import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, input } from '@angular/core';
import { LoggerService } from '../../tpi-services/logger/logger.service';
import { LoginLogoutService } from '../../tpi-services/login-logout/login-logout.service';
import { SessionService } from '../../tpi-services/tpi-session/session.service';
import { AccountInfo } from '../../tpi-models/general/account-info';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { merge } from 'rxjs';
import { DavinciWidgetService } from '../../tpi-services/davinci/davinci-widget.service';
import { TpiIdleService } from '../../tpi-services/shared-services/tpi-idle.service';
import { ModalWrapperComponent } from '@nationwide/internet-servicing-angular-components';
import { DavinciWidgetComponent } from '../../shared/components/davinci-widget/davinci-widget.component';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        RouterLink,
        ModalWrapperComponent,
        DavinciWidgetComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HeaderComponent implements OnInit {
    readonly account = input<AccountInfo>(undefined);
    admin = 1;
    isAgreementAccepted = true;
    isChangePasswordModalOpen = false;
    isLoggedIn = false;
    // eslint-disable-next-line no-magic-numbers
    superUser = 3;
    termsAndConditions = 'terms-and-conditions';
    title = 'Nationwide Policy Inquiry';
    // eslint-disable-next-line no-magic-numbers
    webSupport = 6;
    widgetConfig = {
        policyID: environment.davinci.selfServicePolicyID
    };

    private activatedRoute = inject(ActivatedRoute);
    private changeDetectorRef = inject(ChangeDetectorRef);
    private davinciWidgetService = inject(DavinciWidgetService);
    private loggerService = inject(LoggerService);
    private loginLogoutService = inject(LoginLogoutService);
    private router = inject(Router);
    private sessionService = inject(SessionService);
    private tpiIdleService = inject(TpiIdleService);

    constructor() {
        this.sessionService.loginSubject().subscribe({
            next: (isLogin: boolean) => {
                this.isLoggedIn = isLogin;
            }
        });
    }

    ngOnInit(): void {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            this.activatedRoute.firstChild.url.subscribe((url) => {
                this.isAgreementAccepted = this.termsAndConditions !== url[0]?.path;
            });
        });

        merge(
            this.davinciWidgetService.userCancelled$,
            this.tpiIdleService.onTimeout(),
            this.tpiIdleService.onTimeoutWarning(),
            this.tpiIdleService.onSessionExpireWarning(),
            this.tpiIdleService.onSessionExpireTimeout()
        ).subscribe(() => {
            this.modalClosed();
        });
    }

    logout(): void {
        this.loggerService.info('User logout', { session: this.sessionService.getSession() });
        this.loggerService.logCurrentContents();
        this.sessionService.isLoggedIn = false;
        this.loginLogoutService.logout();
    }

    modalClosed(): void {
        this.isChangePasswordModalOpen = false;
        this.changeDetectorRef.detectChanges();
    }

    openChangePasswordModal(): void {
        this.loggerService.info('Open change password modal', { session: this.sessionService.getSession(), currentRoute: this.router.url });
        this.isChangePasswordModalOpen = true;
        const modal = document?.querySelector('#theModal')?.shadowRoot?.querySelector('div.bolt-modal-wc');
        modal?.querySelector('.bolt-modal-wc--heading')?.setAttribute('style', 'display: none');
    }
}